import Logger from "./Logger";

/***
 *  IE11 and older will return an HTMLCollection instead of a HTMLFormControlsCollection and
 *  we can't read a radio group's selected value from that
 */
function __isOldBrowser(aFormElement, aRadioInputName) {
  if (aFormElement.elements[aRadioInputName]) {
    return typeof aFormElement.elements[aRadioInputName].value === "undefined";
  } else {
    return false;
  }
}

function __getRadioGroupValueFromHtmlCollection(form, inputName) {
  let value = "";
  const htmlCollection = form.elements[inputName];
  if (htmlCollection) {
    for (let i = 0; i < htmlCollection.length; i++) {
      const element = document.getElementById(htmlCollection.item(i).id);
      if (element && element.checked) {
        value = element.value;
        break;
      }
    }
  }
  return value;
}

function __readInputValue(form, inputName) {
  if (__isOldBrowser(form, inputName)) {
    return __getRadioGroupValueFromHtmlCollection(form, inputName);
  } else {
    return form.elements[inputName] ? form.elements[inputName].value : "";
  }
}

export function __testable() {
  return {
    __isOldBrowser,
    __getRadioGroupValueFromHtmlCollection,
    __readInputValue,
  };
}

export function Model(form) {
  let logger = new Logger("NKU Model");

  function getFieldNameForDataAttr(dataAttrName) {
    let tmp = document.querySelector("[" + dataAttrName + "]");
    if (tmp) {
      return tmp.getAttribute(dataAttrName);
    } else return null;
  }

  function getFieldNameForId(id) {
    let tmp = document.getElementById(id);
    return tmp ? tmp.name : null;
  }

  function getValueOfRadioOptionWithId(id) {
    let tmp = document.querySelector(`#${id}`);
    return tmp ? tmp.value : null;
  }

  function formValueForInputName(inputName) {
    return __readInputValue(form, inputName);
  }

  function getFieldValueForId(id) {
    let tmp = document.getElementById(id);
    return tmp ? tmp.value : null;
  }

  const fieldNames = {
    ALREADY_PURCHASED: getFieldNameForDataAttr("data-already-purchased"),
    WHERE_PURCHASED: getFieldNameForDataAttr("data-where-jl-purchased"),
    WHERE_LOWER_PRICE: getFieldNameForDataAttr("data-where-lower-price"),
    WEB_RETAILER_NAME: getFieldNameForDataAttr("data-retailer-website-name"),
    SHOP_RETAILER_NAME: "retailer-shop-name",
    EMAIL: getFieldNameForDataAttr("data-customer-email"),
    ORDER_NUMBER: getFieldNameForId("product-details--order-number"),
    PRODUCT_CODE: getFieldNameForId("product-details--jl-product-code"),
  };

  const radioButtonValues = {
    ALREADY_PURCHASED: getValueOfRadioOptionWithId(
      "already-purchased--yes-option"
    ),
    NOT_ALREADY_PURCHASED: getValueOfRadioOptionWithId(
      "already-purchased--no-option"
    ),
    PURCHASED_IN_JOHN_LEWIS_SHOP: getValueOfRadioOptionWithId(
      "where-jl-purchased--shop-option"
    ),
    PURCHASED_AT_JOHN_LEWIS_ONLINE: getValueOfRadioOptionWithId(
      "where-jl-purchased--online-option"
    ),
  };

  let isAllowedRetailer = null;
  let listeners = [];
  let previousState = {};

  function alreadyPurchasedValue() {
    return formValueForInputName(fieldNames.ALREADY_PURCHASED);
  }

  function wherePurchasedValue() {
    return formValueForInputName(fieldNames.WHERE_PURCHASED);
  }

  function whereLowerPriceValue() {
    return formValueForInputName(fieldNames.WHERE_LOWER_PRICE);
  }

  function purchaseHistoryIsValid() {
    return alreadyPurchasedValue() === radioButtonValues.NOT_ALREADY_PURCHASED;
  }
  function isJLOnlinePurchased() {
    return (
      wherePurchasedValue() === radioButtonValues.PURCHASED_AT_JOHN_LEWIS_ONLINE
    );
  }

  function takeStateSnapshot() {
    return {
      purchaseHistoryValid: purchaseHistoryIsValid(),
      purchasedInAJohnLewisShop:
        alreadyPurchasedValue() === radioButtonValues.ALREADY_PURCHASED &&
        wherePurchasedValue() ===
          radioButtonValues.PURCHASED_IN_JOHN_LEWIS_SHOP,
      alreadyPurchased:
        alreadyPurchasedValue() === radioButtonValues.ALREADY_PURCHASED,
      isJLOnlinePurchased: isJLOnlinePurchased(),

      email: formValueForInputName(fieldNames.EMAIL),
      productCode: formValueForInputName(fieldNames.PRODUCT_CODE),
      orderNumber: formValueForInputName(fieldNames.ORDER_NUMBER),
    };
  }

  function onChange() {
    let newState = takeStateSnapshot();
    if (JSON.stringify(newState) !== JSON.stringify(previousState)) {
      logger.info(`Model state changed to ${JSON.stringify(newState)}`);
      listeners.forEach((f) => f(newState));
      previousState = newState;
    }
  }

  function addFormChangeListener() {
    if (form.addEventListener) {
      form.addEventListener("change", onChange);
    } else if (form.attachEvent) {
      // for earlier Browsers
      form.attachEvent("change", onChange);
    }
  }

  function addListener(callbackFn) {
    listeners.push(callbackFn);
  }

  function updateAllowedRetailerValue(value) {
    logger.debug("updateAllowedRetailerValue " + value);
    isAllowedRetailer = value;
    onChange();
  }

  function resetWherePurchasedQuestion() {
    if (form.elements[fieldNames.WHERE_PURCHASED].value !== null) {
      form.elements[fieldNames.WHERE_PURCHASED].value = null;
    }
  }

  function resetPurchaseQuestions() {
    form.elements[fieldNames.ALREADY_PURCHASED].value = null;
    form.elements[fieldNames.WHERE_PURCHASED].value = null;
    form.dispatchEvent(new Event("change"));
  }

  return {
    init: addFormChangeListener,
    addListener: addListener,
    resetPurchaseQuestions: resetPurchaseQuestions,
    resetWherePurchasedQuestion: resetWherePurchasedQuestion,
    updateAllowedRetailerValue: updateAllowedRetailerValue,
  };
}
